var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.639 10.237a1.501 1.501 0 0 1-.877-.876l-2.761-7.36h-17.5A1.5 1.5 0 0 0 5 3.5v37A1.5 1.5 0 0 0 6.5 42h27a1.5 1.5 0 0 0 1.5-1.502V13l-7.361-2.762Z",
    fill: "#FA6050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v9.499a1.5 1.5 0 0 0 1.5 1.5L35 13 24 2Z",
    fillOpacity: 0.35,
    fill: "#FA6050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.945 22.567c.777 0 1.46.169 2.046.507a3.606 3.606 0 0 1 1.375 1.392c.33.59.495 1.266.495 2.029 0 .77-.165 1.45-.495 2.04a3.606 3.606 0 0 1-1.375 1.392c-.586.338-1.269.506-2.046.506H17.35v-7.866Zm-6.765 0c.505 0 .95.096 1.331.286.38.192.677.457.89.798.213.341.32.742.32 1.204 0 .455-.107.857-.32 1.205-.213.35-.51.618-.89.81-.382.19-.826.285-1.33.285h-1.806v3.277h-1.133v-7.865Zm17.281 0v.98h-3.719v2.409h3.521v.979h-3.52v3.498h-1.134v-7.865h4.852Zm-10.516.991h-1.463v5.884h1.463c.565 0 1.05-.122 1.458-.368.407-.245.72-.59.94-1.034.22-.443.33-.958.33-1.545s-.11-1.101-.33-1.54a2.45 2.45 0 0 0-.94-1.028c-.408-.246-.893-.369-1.458-.369Zm-6.765-.01h-1.805v2.628h1.805c.432 0 .773-.118 1.022-.352.25-.235.374-.558.374-.969 0-.41-.125-.73-.374-.962-.249-.23-.59-.346-1.022-.346Z",
    fill: "#FFF"
  }))));
};
export default SvgPdf;